import React from 'react'
import slider1 from '../../assets/images/slider-image-1.jpeg'
import slider2 from '../../assets/images/slider-image-2.jpeg'
import slider3 from '../../assets/images/slider-image-3.jpeg'
import blog1 from '../../assets/images/blog-img-1.jpeg'
import blog2 from '../../assets/images/blog-img-2.jpeg'
import Slider from 'react-slick'
export default function MainSlider() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  return (
    <div className="row gx-0 my-3">
      <div className="col-md-9">
        <Slider {...settings}>
          <img height={400} className='w-100' src={slider1} alt="Slider1" />
          <img height={400} className='w-100' src={slider2} alt="Slider2" />
          <img height={400} className='w-100' src={slider3} alt="Slider3" />
        </Slider>
      </div>
      <div className="col-md-3">
        <img height={200} className='w-100' src={blog1} alt="blog1" />
        <img height={200} className='w-100' src={blog2} alt="blog2" />

      </div>
    </div>
  )
}
